import Swiper from 'swiper';
import Vue from 'vue';

export default function () {
  const prizes = document.querySelector('.prizes');

  if (prizes) {
    new Vue({
      el: prizes,
      delimiters: ['${', '}}'],
      components: {
      },
      data: {
        manager: window.manager,
        popupIsOpen: false,
      },
      mounted() {
        const sliderBtns = [].slice.call(this.$el.querySelectorAll('.sliderButtons__btn'));
        const sliderWrp = this.$el.querySelector('.swiper-container');

        if (sliderWrp) {
          const slides = [].slice.call(this.$el.querySelectorAll('.prizes__slide'));

          if (slides && slides.length > 1) {
            new Swiper(sliderWrp, {
              slidesPerView: 'auto',
              spaceBetween: 12,
              resistance: true,
              resistanceRatio: 0,
              navigation: {
                prevEl: sliderBtns[0],
                nextEl: sliderBtns[1],
                disabledClass: 'sliderButtons__btn--disabled',
              },
              breakpointsInverse: true,
            });
          }
        }
      },
    });
  }
}



// WEBPACK FOOTER //
// ./new-blocks/prizes/prizes.js